import { render, staticRenderFns } from "./HolidayInfo.vue?vue&type=template&id=fcab8f84&scoped=true"
import script from "./HolidayInfo.vue?vue&type=script&lang=js"
export * from "./HolidayInfo.vue?vue&type=script&lang=js"
import style0 from "./HolidayInfo.vue?vue&type=style&index=0&id=fcab8f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcab8f84",
  null
  
)

export default component.exports